import { Component, Injectable, Input } from "@angular/core";

@Component({
  selector: 'invoice-status',
  templateUrl: './invoice-status.component.html'
})
export class InvoiceStatusComponent {
  @Input()
  status!: string
}